import type { FilterSetScope } from '@revelio/iso-utility';

import { useApplySavedView } from '../../filters/hooks/useApplySavedView';
import { useTabContentConfig } from '../PageConfigProvider/PageConfigProvider';
import { RevelioPageId } from '../PageConfigProvider/types';
import { filterIdToSavedViewScope } from '../SavedViews/filterIdToSavedViewScope';
import { SavedViewsButton } from '../SavedViews/SavedViewsButton';
import { useHasSelectedFilters } from '../SavedViews/useHasSelectedFilters';

/**
 * The analytics pages' saved-filter-sets bookmark: the shared popover bound to
 * this page's scope, its filter selections and its filter-applying dispatch.
 */
export const SavedViewsActionButton = () => {
  const { primaryFilter, revelioPageId } = useTabContentConfig();

  const scope = ((): FilterSetScope => {
    if (revelioPageId === RevelioPageId.COMPANY_SCREENER) {
      return 'company_screener';
    }
    if (revelioPageId === RevelioPageId.GEOGRAPHY_SCREENER) {
      return 'geography_screener';
    }
    if (revelioPageId === RevelioPageId.ROLE_SCREENER) {
      return 'role_screener';
    }
    if (revelioPageId === RevelioPageId.POSTING_DISCOVERY) {
      return 'posting_discovery';
    }
    return primaryFilter
      ? filterIdToSavedViewScope(primaryFilter.id)
      : 'talent_discovery';
  })();

  const applySaved = useApplySavedView();
  const hasSelectedFilters = useHasSelectedFilters();

  return (
    <SavedViewsButton
      scope={scope}
      canCreate={hasSelectedFilters}
      // A dashboard page's sets store its filter map, so they can be
      // previewed on the page and described in the panel.
      canPreview
      onApplySavedView={applySaved}
    />
  );
};
